import { Stack } from '@optimus-web/core';
import { ReservationStatus } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { FormSwitchField, lt } from '@mews/framework';
import { EnumSelectField } from '@mews-commander/form';
import { FILTERS_SPACING, ProductCheckListFilterFieldsDataTestId } from '../constants';
import { FilterValueKey } from '../types';

export const ReservationsSectionFields: React.FC = () => (
    <Stack vertical spacing={FILTERS_SPACING}>
        <EnumSelectField
            multiselect
            compact
            enumClass={ReservationStatus}
            enumPrefix="ReservationStatus"
            name={FilterValueKey.reservationStatus}
            label={lt(TextKey.ReservationStatus)}
            data-test-id={ProductCheckListFilterFieldsDataTestId.reservationStatus}
        />
        <FormSwitchField
            name={FilterValueKey.displayReservationsWithoutProducts}
            label={lt(TextKey.ShowReservationsWithoutProducts)}
            data-test-id={ProductCheckListFilterFieldsDataTestId.showReservationWithoutProducts}
        />
    </Stack>
);
